import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=e3a84a46&scoped=true&"
import script from "./OrderDetail.vue?vue&type=script&lang=js&"
export * from "./OrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderDetail.vue?vue&type=style&index=1&id=e3a84a46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a84a46",
  null
  
)

export default component.exports